<template>
  <div>
    <loading :active.sync="isLoading" :loader="'dots'"  :color="'#2759ab'" :can-cancel="false" :is-full-page="true"></loading>
    <vue-headful title="Credimóvil | Cotiza tu seguro"/>
    <menu-component></menu-component>

    <!-- Banner Area -->
    <section class="banner_area banner_area_6" v-if="!scheduleCallFlag && !processOnline">
    	<div class="container">
    		<h6>En menos de 1 minuto</h6>
    		<h2>Cotiza tu seguro</h2>
    		<ol class="breadcrumb">
                <li></li>
                <li></li>
            </ol>
    	</div>
    </section>
    <section class="banner_area banner_area_6"  v-if="scheduleCallFlag || processOnline">
    	<div class="container">
    		<ol class="breadcrumb">
            </ol>
    	</div>
    </section>
    <!-- Banner Area -->

    <!-- Easy cash Area -->
    <section class="easy_cash_area cot-credict getting_loan_area gla_2">
        <div class="container" v-if="vehicleKey == ''">
            <div class="row mb-5">
                <div class="getting_loan_area gla_2 col-lg-5 back-form">
                    <div class="row getting_inner">
                        <div class="col-lg-10 getting_first">
                            <div class="tittle la">
                                <h2>Pasos para contratar <span>tu seguro</span></h2>
                            </div>
                            <div class="getting_items gi_f wow fadeInUp">
                                <span><img src="images/icons/solicitud.png" alt="Solicitud"></span>
                                <h3>Paso 1</h3>
                                <p>Llena tu solicitud en línea de forma rápida y sencilla</p>
                            </div>
                            <div class="getting_items wow fadeInUp" data-wow-delay="0.3s">
                                <span><img src="images/icons/beneficios.png" alt="Pre-aprobación"></span>
                                <h3>Paso 2</h3>
                                <p>Credimóvil te contactara brindarte la asesoría y la contratación
                                    del mejor seguro para tu necesidades
                                </p>
                            </div>
                            <div class="getting_items wow fadeInUp" data-wow-delay="0.6s">
                                <span><img src="images/icons/b-step-2.png" alt="Beneficios"></span>
                                <h3>Paso 3</h3>
                                <p>Te enviaremos la póliza del seguro que elegiste al momento</p>
                            </div>
                            <div class="getting_items wow fadeInUp" data-wow-delay="0.6s">
                                <span><img src="images/icons/pre-aprobacion.png" alt="Beneficios"></span>
                                <h3>Paso 4</h3>
                                <p>¡Listo! Siéntete seguro para realizar tus sueños, estás protegido con nosotros</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 back-form-2">
                    <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
                        <div class="row">
                            <div class="col-12 text-center title-seguro">
                                <h6>DATOS DEL VEHÍCULO</h6>
                                <hr>
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Modelo*</h6>
                                <select class="post_select" id="model" :class="{ 'error': $v.form.selectedModel.$invalid }">
                                  <option value="">Modelo</option>
                                  <option v-for="model in models">{{model}}</option>
                                </select>
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Marca*</h6>
                                <select class="post_select" id="brand" :disabled="form.selectedModel == ''" :class="{ 'error': $v.form.selectedBrand.$invalid }">
                                  <option value="">Marca</option>
                                  <option v-for="brand in brands">{{brand}}</option>
                                </select>
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>Versión*</h6>
                                <select class="post_select2" id="version" :disabled="form.selectedBrand == ''" :class="{ 'error': $v.form.selectedVersion.$invalid }">
                                  <option value="">Versión</option>
                                  <option v-for="version in versions">{{version}}</option>
                                </select>
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>Descripción*</h6>
                                <select class="post_select2" id="description" :disabled="form.selectedVersion == ''" :class="{ 'error': $v.form.selectedDescription.$invalid }">
                                  <option value="">Descripción</option>
                                  <option v-for="description in descriptions" > {{description}}</option>
                                </select>
                            </div>
                            <div class="col-12 text-center title-seguro">
                                <h6>DATOS DEL SOLICITANTE</h6>
                                <hr>
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>Nombre(s)*</h6>
                                <input type="text" class="post_select" id="name" name="name" v-model="form.fullName" :class="{ 'error': $v.form.fullName.$invalid }">
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Sexo*</h6>
                                <select class="post_select" id="gender" :class="{ 'error': $v.form.gender.$invalid }">
                                  <option value="Masculino">Masculino</option>
                                  <option value="Femenino">Femenino</option>
                                </select>
                            </div>
                            <!-- <div class="col-lg-6 select_from">
                                <h6>Edad*</h6>
                                <input type="text" class="post_select" id="edad" name="edad" v-only-numbers v-model="form.age" :class="{ 'error': $v.form.age.$invalid }">
                            </div> -->
                            <div class="col-lg-6 select_from">
                              <h6>Fecha de nacimiento*</h6>
                              <div class="input-icons">
                                <input type="text" readonly class="post_select input-field" id="birthday" name="birthday" style="cursor: pointer">
                                <i class="fa fa-angle-down icon" style="color: white; bottom: 16px;" v-on:click=selectBirthDay()></i>
                              </div>
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Correo electrónico*</h6>
                                <input type="email" class="post_select" id="email" name="email" v-model="form.email" :class="{ 'error': $v.form.email.$invalid }">
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Número de teléfono*</h6>
                                <input type="tel" class="post_select" id="phone" name="phone" v-only-numbers v-model="form.phone" :class="{ 'error': $v.form.phone.$invalid }">
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Código postal*</h6>
                                <input type="text" class="post_select" id="postcode" name="postcode" v-only-numbers v-model="form.postcode" :class="{ 'error': $v.form.postcode.$invalid }">
                            </div>
                            <div class="col-lg-6 select_from">
                                <h6>Forma de pago*</h6>
                                <select class="post_select" v-model="form.paymentMethod" id="paymentMethod" :class="{ 'error': $v.form.paymentMethod.$invalid }">
                                  <option value="Contado">Contado</option>
                                  <option value="Semestral">Semestral</option>
                                  <option value="Trimestral">Trimestral</option>
                                  <option value="Mensual">Mensual</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="theme_btn btn" id="js-contact-btn" :disabled="$v.form.$invalid" v-on:click="saveQuotation()" >Cotizar mi seguro</button>
                            <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
        <div class="container" v-if="vehicleKey != '' && !buyInsuranceFlag">
            <div class="row">
                <div class="getting_loan_area gla_2 col-lg-5 offset-lg-1 back-form">
                    <div class="row getting_inner">
                        <div class="col-12 text-center title-seguro">
                            <h6>DATOS DEL VEHÍCULO</h6>
                            <hr>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Modelo</h3>
                            <p>{{form.selectedModel}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Marca</h3>
                            <p>{{form.selectedBrand}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Versión</h3>
                            <p>{{form.selectedVersion}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Descripción</h3>
                            <p>{{form.selectedDescription}}</p>
                        </div>
                    </div>
                </div>
                <div class="getting_loan_area gla_2 col-lg-5 back-form">
                    <div class="row getting_inner">
                        <div class="col-12 text-center title-seguro">
                            <h6>DATOS DEL SOLICITANTE</h6>
                            <hr>
                        </div>
                        <div class="col-12 data-items">
                            <h3>Nombre</h3>
                            <p>{{form.fullName}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Sexo</h3>
                            <p>{{form.gender}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Edad</h3>
                            <p>{{form.age}}</p>
                        </div>
                        <div class="col-12 data-items">
                            <h3>Email</h3>
                            <p>{{form.email}}</p>
                        </div>
                        <div class="col-12 data-items">
                            <h3>Teléfono</h3>
                            <p>{{form.phone}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Código postal</h3>
                            <p>{{form.postcode}}</p>
                        </div>
                        <div class="col-6 data-items">
                            <h3>Forma de pago</h3>
                            <p>{{form.paymentMethod}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="buyInsuranceFlag && !scheduleCallFlag && !processOnline">
          <div class="row mb-5">
            <div class="getting_loan_area gla_2 col-lg-12 back-form">
                    <div class="row getting_inner">
                        <div class="col-lg-12 getting_first">
                            <div class="tittle">
                                <h2>Comienza tu proceso</h2>
                                <p>Para continuar con el trámite de tu crédito requerimos información adicional.<br> ¿Cómo deseas continuar con el proceso?</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 pb-3 border-box">
                          <div class="row">
                            <div class="col-lg-12 d-flex justify-content-center">
                              <img src="images/icons/loan-7.png" style="width: 90px;">
                            </div>
                            <div class="col-lg-12">
                              <br>
                              <h3 class="text-center" style="color: #f59019;">Contactar con un agente</h3>
                            </div>
                            <div class="col-lg-12 ">
                              <br>
                              <p class="text-center pl-lg-5 pr-lg-5 pr-sm-0 pl-sm-0" style="font-size: 20px;">Un asesor se comunicará contigo por teléfono para orientarte en el proceso</p>
                              <br>
                            </div>
                            <div class="col-lg-12  d-flex justify-content-center">
                              <button class="theme_btn btn" v-on:click="scheduleCall()">Agendar llamada</button>
                            </div>
                          </div>
                        </div> 
                        <div class="col-lg-6 col-md-12 pb-3 pt-3 border-box">
                          <div class="row">
                            <div class="col-lg-12 d-flex justify-content-center">
                              <img src="images/icons/presentation.png" style="width: 100px;">
                            </div>
                            <div class="col-lg-12">
                              <br>
                              <h3 class="text-center" style="color: #f59019;">Hacer el trámite en línea</h3>
                            </div>
                            <div class="col-lg-12 ">
                              <br>
                              <p class="text-center pl-lg-5 pr-lg-5 pr-sm-0 pl-sm-0" style="font-size: 20px;">El trámite continuará por este medio totalmente en línea</p>
                              <br>
                            </div>
                            <div class="col-lg-12  d-flex justify-content-center">
                              <button class="theme_btn btn" v-on:click="completeProcess()">Completar trámite</button>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
          </div>
        </div>
        <div class="container" v-if="!processOnline" :style="[ !scheduleCallFlag ? { 'display': 'none' } : { 'display': 'block'} ]">
          <div class="row mb-5">
            <div class="getting_loan_area gla_2 col-lg-12 back-form">
              <div class="row getting_inner">
                <div class="col-lg-12 getting_first">
                  <div class="tittle">
                    <h2>Agendar llamada</h2>
                  </div>
                  <div class="col-lg-12">
                    <form>
                      <div class="row">
                        <div class="col-lg-6 col-md-12 select_from pb-3">
                          <h6>Fecha</h6>
                          <div class="input-icons">
                            <input readonly class="post_select_new" id="date" name="date" style="cursor: pointer">
                            <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate()></i>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 select_from pb-3">
                          <h6>Hora</h6>
                          <select class="post_select_new" id="hour" >
                            <option v-for="hour in hours" v-bind:key="hour.value">{{hour.value}}</option>
                          </select>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-end pt-3 pb-5">
                          <button class="theme_btn btn" type="button" v-on:click="schedule()">Agendar</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" :style="[ !processOnline ? { 'display': 'none' } : { 'display': 'block'} ]">
          <QuotationProcess :dataContractor="dataContractor" :dataInsurance="insuranceData" :vehicleKey="vehicleKey"/>
        </div>
    </section>
    <!-- End Easy cash Area -->

    <section class="services_details back-form-2"  v-if="vehicleKey != '' && !buyInsuranceFlag">
    	<div class="container">
          <div class="getting_loan_area gla_2 col-lg-12 back-form-2 py-0">
              <div class="row getting_inner" v-for="quote in quotations">
                  <div class="col-12 text-center title-seguro">
                      <h6>{{quote.tittle}}</h6>
                      <hr>
                  </div>
                  <div clas="col-lg-12 p-0">
                      <div class="col-lg-12">
                        <div class="table-responsive">
                          <table class="table table-bordered table-insurance">
                            <thead>
                              <tr>
                                <th width="100">Compañía</th>
                                <th>Daños materiales</th>
                                <th>Robo total</th>
                                <th v-if="form.paymentMethod !== 'Contado'">Pago inicial</th>
                                <th v-if="form.paymentMethod !== 'Contado'">Pagos</th>
                                <!-- <th>Daños a 3ros</th>
                                <th>Daños catastróficos</th>
                                <th>Gastos médicos  a ocupantes</th>
                                <th>Asistencia vial</th>
                                <th>Gastos legales</th> -->
                                <th>Precio Total</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="insure in quote.data">
                                <td>
                                  <img src="images/socios/qualitas.png" v-if="insure.cia == 'qualitas'">
                                  <img src="images/socios/mapfre.png" v-if="insure.cia == 'mapfre'">
                                  <img src="images/socios/afirme.png" v-if="insure.cia == 'afirme'">
                                  <img src="images/socios/chubb.png" v-if="insure.cia == 'chubb'">
                                  <img src="images/socios/hdi.png" v-if="insure.cia == 'hdi'">
                                  <img src="images/socios/gnp.png" v-if="insure.cia == 'gnp'">
                                  <img src="images/socios/zurich.png" v-if="insure.cia == 'zurich'">
                                  <img src="images/socios/ana.png" v-if="insure.cia == 'ana'">
                                </td>
                                <td>{{insure.material_damage}}%</td>
                                <td>{{insure.steal_total}}%</td>
                                <td v-if="form.paymentMethod !== 'Contado'">${{formatPrice(insure.first_payment)}}</td>
                                <td v-if="form.paymentMethod !== 'Contado'" >${{formatPrice(insure.payments)}}</td>
                                <!-- <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td> -->
                                <td>${{formatPrice(insure.price_total)}}</td>
                                <td class="text-center">
                                  <button class="theme_btn btn mr-3" v-on:click="buyInsurance(insure)">Comprar</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- <div class="col-lg-3 d-inline-block">
                          <p style="color: white"><b>Pago inicial:</b> ${{formatPrice(insure.first_payment)}}</p>
                      </div>
                      <div class="col-lg-3 d-inline-block">
                          <p style="color: white"><b>Pagos de:</b> ${{formatPrice(insure.payments)}}</p>
                      </div>
                      <button class="theme_btn btn float-right mr-3">Comprar</button> -->
                  </div>
              </div>
          </div>
      </div>
    </section>

     <!-- Services Details Area -->
    <section class="services_details ofrece-seguro" v-if="vehicleKey == '' && !buyInsuranceFlag">
    	<div class="container">
    		<div class="features_b">
    			<h3>Beneficios</h3><br>
    		</div>
    		<div class="row">
    			<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-proteger"></i>
    				<h4>Convenios con las mejores aseguradoras</h4>
    			</div>
    			<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-etiqueta-1"></i>
    				<h4>Hasta el 20% de descuento</h4>
    			</div>
    			<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-etiqueta"></i>
    				<h4>Precios competitivos</h4>
    			</div>
    			<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-nombramiento"></i>
    				<h4>Comodidad de pagos</h4>
    			</div>
    			<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-gdpr"></i>
    				<h4>Asesoría legal</h4>
				</div>
				<div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
    				<i class="flaticon-choque-de-autos"></i>
    				<h4>Daños a terceros</h4>
    			</div>
    		</div>
    	</div>
    </section>
	<!-- Services Details Area -->

	<!-- Socios -->
	<section class="socios-comerciales" v-if="!buyInsuranceFlag">
		<div class="container">
			<div class="spacer-title">
                <h3>Socios comerciales</h3>
            </div>
			<div class="col-12">
				<div class="row">
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/qualitas.png" alt="Qualitas">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/chubb.png" alt="CHUBB">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/hdi.png" alt="HDI Seguros">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/gnp.png" alt="GNP Seguros">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/zurich.png" alt="Zurich">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/mapfre.png" alt="Mapfre">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/afirme.png" alt="afirme seguros">
					</div>
					<div class="col-lg-3 col-md-4 col-sm-6">
						<img src="images/socios/ana.png" alt="ana seguros">
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- End Socios -->
  </div>
</template>

<script>
  import { required, minLength, between } from 'vuelidate/lib/validators';
  import statesAndTownship from '../assets/estados-municipios.json';
  import QuotationProcess from './QuotationProcess';

  var dateToday = new Date(); 

  export default {
    name: 'QuoteInsurance',
    data() {
      return {
        states: [],
        townships: [],
        isLoading: false,
        models: [],
        brands: [],
        versions: [],
        descriptions: [],
        vehicleKey: '',
        buyInsuranceFlag: false,
        scheduleCallFlag: false,
        processOnline: false,
        quoteInsuranceId: 0,
        paymentMethod: '',
        gender: '',
        form: {
            fullName: '',
            age: '',
            email: '',
            phone: '',
            gender: 'Masculino',
            postcode: '',
            paymentMethod: 'Contado',
            selectedModel: '',
            selectedBrand: '',
            selectedVersion: '',
            selectedDescription: ''
        },
        dataContractor: {
            id: 0,
            fullName: '',
            age: '',
            birthDay: '',
            email: '',
            phone: '',
            gender: '',
            postcode: '',
            paymentMethod: '',
            selectedModel: '',
            selectedBrand: '',
            selectedVersion: '',
            selectedDescription: ''
        },
        scheduleCallForm: {
          date: '',
          hour: '',
        },
        hours: [
          { value: '08:30' },
          { value: '09:00' },
          { value: '10:00' },
          { value: '11:00' },
          { value: '12:00' },
          { value: '13:00' },
          { value: '14:00' },
          { value: '15:00' },
          { value: '16:00' },
          { value: '17:00' },
          { value: '18:00' },
          { value: '19:00' },
          { value: '20:00' },
        ],
        dataInsurance: {
          id: 0,
          cia: '',
          material_damage: '',
          steal_total: '',
          initial_payment: 0
        },
        insuranceData: {
          id: 0,
          cia: '',
          duty: '',
          initial_payment: 0,
          iva: '',
          material_damage: 0,
          net_price: '',
          payments: '',
          price_total: '',
          recharges: '',
          steal_total: 0
        },
        quotations: [
          {
            tittle: 'AMPLIA',
            data: []
          }// ,{
          //   tittle: 'LIMITADA',
          //   data: []
          // },{
          //   tittle: 'RESPONSABILIDAD CIVIL',
          //   data: []
          // }
        ],
        quotationsToExecute: [
          { cia: 'afirme', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'afirme', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'afirme', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'afirme', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'afirme', deductible: '3|5', coverage: 'RC' },
          // { cia: 'afirme', deductible: '5|10', coverage: 'RC' },
          { cia: 'qualitas', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'qualitas', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'qualitas', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'qualitas', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'qualitas', deductible: '3|5', coverage: 'RC' },
          // { cia: 'qualitas', deductible: '5|10', coverage: 'RC' },
          { cia: 'mapfre', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'mapfre', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'mapfre', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'mapfre', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'mapfre', deductible: '3|5', coverage: 'RC' },
          // { cia: 'mapfre', deductible: '5|10', coverage: 'RC' },
          { cia: 'chubb', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'chubb', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'chubb', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'chubb', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'chubb', deductible: '3|5', coverage: 'RC' },
          // { cia: 'chubb', deductible: '5|10', coverage: 'RC' },
          { cia: 'hdi', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'hdi', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'hdi', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'hdi', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'hdi', deductible: '3|5', coverage: 'RC' },
          // { cia: 'hdi', deductible: '5|10', coverage: 'RC' },
          { cia: 'gnp', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'gnp', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'gnp', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'gnp', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'gnp', deductible: '3|5', coverage: 'RC' },
          // { cia: 'gnp', deductible: '5|10', coverage: 'RC' },
          { cia: 'zurich', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'zurich', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'zurich', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'zurich', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'zurich', deductible: '3|5', coverage: 'RC' },
          // { cia: 'zurich', deductible: '5|10', coverage: 'RC' },
          { cia: 'ana', deductible: '3|5', coverage: 'Amplia' },
          { cia: 'ana', deductible: '5|10', coverage: 'Amplia' },
          // { cia: 'ana', deductible: '3|5', coverage: 'Limitada' },
          // { cia: 'ana', deductible: '5|10', coverage: 'Limitada' },
          // { cia: 'ana', deductible: '3|5', coverage: 'RC' },
          // { cia: 'ana', deductible: '5|10', coverage: 'RC' },
        ]
      }
    },
    validations() {
      return {
        form: {
            fullName: { required },
            // age: { required },
            email: { required },
            phone: { required },
            gender: { required },
            postcode: { required },
            paymentMethod: { required },
            selectedModel: { required },
            selectedBrand: { required },
            selectedVersion: { required },
            selectedDescription: { required }
        },
        scheduleCallForm: {
          date: { required },
          hour: { required },
        }
      }
    },
    components: {
      QuotationProcess
    },
    methods: {
      validateForm() {
        var errors = 0;

        if (this.form.selectedModel == '')
          errors++;
        if (this.form.selectedBrand == '')
          errors++;
        if (this.form.selectedVersion == '')
          errors++;
        if (this.form.selectedDescription == '')
          errors++;
        if (this.form.fullName == '')
          errors++;
        if (this.form.age == '')
          errors++;
        if (this.form.email == '')
          errors++;
        if (this.form.phone == '')
          errors++;
        if (this.form.paymentMethod == '')
          errors++;
        if (this.form.gender == '')
          errors++;

        return (errors > 0);
      },
      refreshSelects() {
        $('#model').niceSelect('update');
        $('#brand').niceSelect('update');
        $('#version').niceSelect('update');
        $('#description').niceSelect('update');
        $('#state').niceSelect('update');
        $('#city').niceSelect('update');
        $('#date').datepicker({
            dateFormat: 'dd-mm-yy',
            changeMonth: true,
            minDate: dateToday,
            beforeShowDay: function(date) { 
             var day = date.getDay(); 
             return [(day != 0), '']; 
            } 
        });
        $('#birth_date2').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
          changeYear: true,
          yearRange: "-100:+0"
        });
        $('#birthday').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
          changeYear: true,
          yearRange: "-100:+0"
        });
        $('#constancy_date').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
        });
        $('#invoice_date').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
        });
        // $('#start_date').datepicker({
        //   dateFormat: 'dd-mm-yy',
        //   changeMonth: true,
        //   minDate: dateToday,
        //   beforeShow: function() { 
        //     $(this).datepicker('option', 'maxDate', $('#end_date').val()); 
        //   }
        // });
        // $('#end_date').datepicker({
        //   dateFormat: 'dd-mm-yy',
        //   changeMonth: true,
        //   beforeShow: function() { 
        //   $(this).datepicker('option', 'minDate', $('#start_date').val()); 
        //     if ($('#start_date').val() === '') $(this).datepicker('option', 'minDate', 0);        
        //   }
        // });
        $('#beneficiary_birth_date').datepicker({
          dateFormat: 'dd-mm-yy',
          changeMonth: true,
          changeYear: true,
          yearRange: "-100:+0"
        });
      },
      onChangeTerm() {
        setTimeout(() => {
        this.refreshSelects();
            $('#term').on('change', () => {
                this.formFinancing.term = Number($('#term').val());
                // this.refreshSelects();
            });
        }, 100)
      },
      selectDate() {
        $('#date').datepicker('show');
      },
      selectBirthDay() {
        $('#birthday').datepicker('show');
      },
      getModels() {
        this.$InsuranceService.getModels().then((result) => {
          this.models = result.data.model;

          setTimeout(() => {
            this.refreshSelects();

            $('#model').on('change', () => {
              this.form.selectedModel = $('#model').val();
              $('#brand').val('');
              $('#version').val('');
              $('#description').val('');

              this.getBrands();

              setTimeout(() => {
                this.refreshSelects();
              }, 100);
            });
          }, 100);
        }, (err) => alert(err));
      },
      getBrands() {
        if (this.form.selectedModel != '') {
          const data = {
            model: this.form.selectedModel
          };

          this.$InsuranceService.getBrands(data).then((result) => {
            this.brands = result.data.brand;

            setTimeout(() => {
              this.refreshSelects();

              $('#brand').on('change', () => {
                this.form.selectedBrand = $('#brand').val();
                $('#version').val('');
                $('#description').val('');

                this.getVersions();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));
        }
      },
      getVersions() {
        if (this.form.selectedBrand != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand
          };

          this.$InsuranceService.getVersions(data).then((result) => {
            this.versions = result.data.version;

            setTimeout(() => {
              this.refreshSelects();

              $('#version').on('change', () => {
                this.form.selectedVersion = $('#version').val();
                $('#description').val('');

                this.getDescriptions();
                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));
        }
      },
      getDescriptions() {
        if (this.form.selectedVersion != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand,
            version: this.form.selectedVersion
          };

          this.$InsuranceService.getDescriptions(data).then((result) => {
            this.descriptions = result.data.description;

            setTimeout(() => {
              this.refreshSelects();

              $('#description').on('change', () => {
                this.form.selectedDescription = $('#description').val();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));
        }
      },
      calculateAge(date) {
        const today = new Date();
        const birthdate = new Date(date);
        let age = today.getFullYear() - birthdate.getFullYear();
        const m = today.getMonth() - birthdate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
          age--;
        }

        return age;
      },
      saveQuotation() {
        this.isLoading = true;

        event.preventDefault();

        this.form.age = this.calculateAge(moment($('#birthday').val(), 'DD-MM-YYYY').format('YYYY/MM/DD')).toString();

        var data = {
          data: {
            full_name: this.form.fullName,
            age: this.calculateAge(moment($('#birthday').val(), 'DD-MM-YYYY').format('YYYY/MM/DD')),
            email: this.form.email,
            phone: this.form.phone,
            gender: $('#gender').val(),
            postcode: this.form.postcode,
            payment_method: $('#paymentMethod').val(),
            vehicle_model: this.form.selectedModel,
            vehicle_brand: this.form.selectedBrand,
            vehicle_version: this.form.selectedVersion,
            vehicle_description: this.form.selectedDescription
          }
        };

        var data2 = {
          birthday: moment($('#birthday').val(), 'DD-MM-YYYY').format('YYYY-MM-DD'),
		      email: this.form.email,
		      fullName: this.form.fullName,
		      gender: $('#gender').val(),
		      paymentMethod: $('#paymentMethod').val(),
		      phone: this.form.phone,
		      postcode: this.form.postcode,
		      vehicleBrand: this.form.selectedBrand,
		      vehicleDescription: this.form.selectedDescription,
		      vehicleModel: this.form.selectedModel,
          vehicleVersion: this.form.selectedVersion,
          origin: 'Web'
        }
        this.form.gender = $('#gender').val();
        this.form.paymentMethod = $('#paymentMethod').val();

        this.$InsuranceService.saveQuotation(data).then((result) => {
          
          this.$PolicyService.saveQuotation(data2).then((result1) => {
            if (result1.response) {
              this.dataContractor.id = result1.data.id;
              this.dataContractor.fullName = data2.fullName;
              this.dataContractor.age = this.form.age;
              this.dataContractor.birthDay = data2.birthday;
              this.dataContractor.email = data2.email;
              this.dataContractor.phone = data2.phone;
              this.dataContractor.gender = data2.gender;
              this.dataContractor.postcode = data2.postcode;
              this.dataContractor.paymentMethod = data2.paymentMethod;
              this.dataContractor.selectedModel = data2.vehicleModel;
              this.dataContractor.selectedBrand = data2.vehicleBrand;
              this.dataContractor.selectedVersion = data2.vehicleVersion;
              this.dataContractor.selectedDescription = data2.vehicleDescription;

              this.vehicleKey = result.data.vehicle_key;
              this.quoteInsuranceId = result.data.quoteInsuranceId;
              window.scrollTo(0, 0);
              this.getAllQuotes();
            }
          }, (err) => { 
            this.isLoading = false;
            alert(err.message);
          });
        }, (err) => {
          this.isLoading = false;
          alert(err.msg);
        });
      },
      getQuoteInsurance(data, index) {
        this.$InsuranceService.getQuote(data).then((result) => {
          if (result.data.length > 0) {
            var newData = result.data[0];

            newData.materialDamage = result.data.deductible;
            if (data.deductible == '3|5') {
              newData.material_damage = 3;
              newData.steal_total = 5;
            } else {
              newData.material_damage = 5;
              newData.steal_total = 10;
            }

            if (data.coverage == 'Amplia')
              this.quotations[0].data.push(newData);
            if (data.coverage == 'Limitada')
              this.quotations[1].data.push(newData);
            if (data.coverage == 'RC')
              this.quotations[2].data.push(newData);

            this.isLoading = false;
          }
          // else if (index == 15) {
          //   this.isLoading = false;
          //   alert('Por el momento no hay cotizaciones para este vehículo, favor de intentar después');
          //   location.reload();
          // }
        }, (err) => {
          alert(err);
          console.log(err);
        });
      },
      getAllQuotes() {
        this.quotationsToExecute.forEach((item, index) => {
          var dataToSend = item;

          dataToSend.vehicle_key = this.vehicleKey;
          dataToSend.age = this.form.age;
          dataToSend.model = this.form.selectedModel;
          dataToSend.gender = this.form.gender;
          dataToSend.postcode = this.form.postcode;

          this.getQuoteInsurance(dataToSend, index);
        });
      },
      formatPrice(value) {
          let num = (value/1).toFixed(2);
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      buyInsurance(dataInsurance) {
        this.isLoading = true;
        var data = {
          data: {
            id: this.quoteInsuranceId,
            cia: dataInsurance.cia,
            material_damage: dataInsurance.material_damage,
            steal_total: dataInsurance.steal_total,
            initial_payment: parseInt(dataInsurance.first_payment)
          }
        };
        this.insuranceData.id = this.dataContractor.id;
        this.insuranceData.cia = dataInsurance.cia;
        this.insuranceData.duty = dataInsurance.duty;
        this.insuranceData.iva = dataInsurance.iva;
        this.insuranceData.net_price = dataInsurance.net_price;
        this.insuranceData.payments = dataInsurance.payments;
        this.insuranceData.price_total = dataInsurance.price_total;
        this.insuranceData.recharges = dataInsurance.recharges;
        this.insuranceData.material_damage = dataInsurance.material_damage;
        this.insuranceData.steal_total = dataInsurance.steal_total;
        this.insuranceData.initial_payment = parseInt(dataInsurance.first_payment);
        
        var data2 = {
          id: this.dataContractor.id,
          duty: dataInsurance.duty,
          iva: dataInsurance.iva,
          netPrice: dataInsurance.net_price,
          priceTotal: dataInsurance.price_total,
          firstPayment: dataInsurance.first_payment,
          payments: dataInsurance.payments,
          recharges: dataInsurance.recharges,
          cia: dataInsurance.cia,
          coverage:"Amplia",
          deductible: dataInsurance.material_damage + '|' + dataInsurance.steal_total,
          budget: "0"
        };

        this.$PolicyService.newInsurance(data2).then((res) => {
          if (res.response) {
            this.buyInsuranceFlag = true;
            window.scrollTo(0, 0);
            this.$InsuranceService.quoteInsurance(data).then((result) => {
              this.isLoading = false;
            }, (err) => alert(err.msg));
          }
        }, (err) => alert(err.message));
      },
      scheduleCall() {
        this.scheduleCallFlag = true;
      },
      completeProcess() {
        this.processOnline = true; 
      },
      schedule() {
        this.scheduleCallForm.hour = $('#hour').val();
        this.scheduleCallForm.date = $('#date').val();
        if (!this.scheduleCallForm.date || !this.scheduleCallForm.hour) {
          alert('Favor de llenar los datos correspondientes para agendar la cita');
          return;
        }

        var today = moment(new Date()).format('YYYY-MM-DD');
        var actualHour = new Date().getHours();
        var minutes = new Date().getMinutes();
        var date = moment($('#date').val()).format('YYYY-DD-MM');
        var hour = $('#hour').val();

        if ( date == today ) {
          var selectedHour = hour.slice(0, 2);
          var selectedMinutes = hour.slice(3, 5);
          console.log(Number(minutes));
          if (Number(selectedHour) < actualHour ) {
            alert('Favor de elegir fecha y hora válidas');
            return;
          } else {
            if ( Number(selectedMinutes) < Number(minutes) && Number(selectedHour) == actualHour) {
              alert('Favor de elegir fecha y hora válidas');
              return;
            }
          }
        }

        var data = {
          data: {
            id: this.quoteInsuranceId.toString(),
            date_contact: moment($('#date').val()).format('YYYY-DD-MM'),
            hour_contact: this.scheduleCallForm.hour,
            type_contact: 'Agendar llamada'
          }
        };

        this.$InsuranceService.scheduleCall(data).then((result) => {
          console.log(result);
          alert('En breve será contactado por un asesor');
          window.location = '/';
        }, (err) => alert(err.msg));
        
      }
    },
    
    created() {
      
      this.getModels();
    },
  }
</script>

<style lang="scss">
  .error {
    border-color: red !important;
  }

  .post_select_new {
    position: relative;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: none;
    outline: none;
    font: 400 22px/40px "Source Sans Pro", sans-serif;
    padding: 6px 25px;
    height: 55px;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 100%;
    margin-bottom: 20px;
    // background-color: transparent;
    &:after {
      display: none;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 20px;
      font: normal normal normal 16px/40px FontAwesome;
      color: #151515;
    }
    .list {
      width: 100%;
      border-radius: 0;
      margin: 0;
      border: 0;
      box-shadow: none;
      outline: none;
      box-shadow: 1px 0px 7px 0px rgba(22, 43, 70, 0.1);
    }
  }

  .input-icons {
    width: 100%;
    margin-bottom: 0px;
    i {
      position: absolute;
      bottom: 44px;
      right: 8px;
      cursor: pointer;
    }
  }

  .nice-select .current {
      width: -webkit-fill-available !important;
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }

  .border-box {
    -webkit-box-shadow: 1px 4px 3px -1px rgba(156,156,156,1);
    -moz-box-shadow: 1px 4px 3px -1px rgba(156,156,156,1);
    box-shadow: 1px 4px 3px -1px rgba(156,156,156,1);
    border-radius: 0px 0px 40px 0px;
    -moz-border-radius: 0px 0px 40px 0px;
    -webkit-border-radius: 0px 0px 40px 0px;
    border: 0px solid #000000;
  }
</style>



// WEBPACK FOOTER //
// src/views/QuoteInsurance.vue